/*
 * @Description:
 * @Version: 1.0
 * @Author: changfeng
 * @Date: 2024-03-05 10:41:10
 * @LastEditors: changfeng
 * @LastEditTime: 2024-10-09 10:33:49
 */

import React, { useEffect, useState, useRef } from "react";
import "./index.less";
import { Button, Divider, Flex, Spin } from "antd";

import MetaLogo from "@/assets/logo/logo_fb.png";
import SafeIcon from "@/assets/icons/account/安全@2x.png";
import ConnectIcon from "@/assets/icons/profiles.svg";
import AddProfiels from "@/assets/icons/addProfiles.svg";
import ProFilesModal from "./components/ProfilesModal";
import { fetchFacebookAuthList, fetchFacebookSetting, FacebookAUthorization } from "@/api/modules/AdAccount";
import { useSelector } from "react-redux";
import AccountTable from "@/pages/AdAccount/components/AccountTable";
import { useTranslation } from "react-i18next";
import { CloseCircleOutlined } from "@ant-design/icons";
import noProfileImg from "@/assets/images/adAccount/noProfile.png";
import facebookIcon from "@/assets/icons/account/facebook.png";
import LoadingPage from "@/components/loading";

const AdAccount = () => {
	const { t } = useTranslation();
	const actionRef = useRef();
	const { currentUser, currentTeam } = useSelector((state: any) => state.global);

	const [isLoading, setIsLoading] = useState<boolean>(true);
	const [facebookProfiles, setFacebookProfiles] = useState([]);
	const [openProfilesModal, setOpenProfilesModal] = useState<boolean>(false);

	useEffect(() => {
		fetchFacebookAuthList().then(res => {
			setFacebookProfiles(res.data.list);
			setIsLoading(false);
		});
	}, [currentTeam]);

	const handleAuth = () => {
		fetchFacebookSetting().then(res => {
			// FacebookAUthorization({ appId: res.data?.appId, uid: currentUser?.id });
			window.open(res.data);
		});
	};

	const removeProfileCallBack = () => {
		fetchFacebookAuthList().then(res => {
			setFacebookProfiles(res.data.list);
			setIsLoading(false);
		});
		if (actionRef?.current) {
			actionRef?.current?.reload();
		}
	};

	if (isLoading) {
		return <LoadingPage />;
	}

	return (
		<div className="account_box">
			<div className="account_header">
				<span>{t("account.title")} </span>
				<Divider type="vertical" style={{ color: "#E9EEF2", height: "2.5rem", marginLeft: "1.5rem", marginRight: "1.5rem" }} />
				<img src={MetaLogo} style={{ width: "42px" }} alt={""} />
				<span style={{ marginLeft: "0.75rem" }}>Meta Ads</span>
			</div>
			<div className="account_container">
				{(!facebookProfiles || facebookProfiles.length <= 0) && (
					<div className="account_noProfiles">
						<img src={noProfileImg} alt="" />
						<span className="intro">{t("account.blank.message")}</span>
						<Button className="account_noProfiles_button" onClick={() => handleAuth()}>
							{t("account.blank.button")}
						</Button>
					</div>
				)}
				{facebookProfiles && facebookProfiles.length > 0 && (
					<div className="account_container_inner">
						<div className="account_profiles_card">
							<div className={`profiles_card ${currentUser.id !== currentTeam?.ownerId && "unclickable"}`}>
								<div
									className="profiles_card_item"
									onClick={() => {
										setOpenProfilesModal(true);
									}}
									style={{ cursor: "pointer" }}
								>
									<div className="profiles_card_container">
										<div className="profiles_card_left">
											<img src={ConnectIcon} alt="" />
										</div>
										<div className="profiles_card_right">
											<div className="top">
												<span className="icon">
													<img src={MetaLogo} style={{ width: "24px" }} alt={""} />
												</span>
												<span className="title">{t("account.profile.card1.title")}</span>
											</div>
											<div>
												<span className="count">{facebookProfiles?.length}</span>
												<span className="units">{t("account.profile.card1.message")}</span>
											</div>
										</div>
									</div>
								</div>
								<div
									className="profiles_card_item2"
									onClick={() => {
										handleAuth();
									}}
									style={{ cursor: "pointer" }}
								>
									<div className="profiles_card_container">
										<div className="profiles_card_left">
											<img src={AddProfiels} alt={""} />
										</div>
										<div className="profiles_card_right">
											<span>{t("account.profile.card2.title")}</span>
										</div>
									</div>
								</div>
							</div>
						</div>
						{currentUser.id !== currentTeam?.ownerId && (
							<div className="limit_tip">
								<CloseCircleOutlined />
								<span className="text">{t("account.member.no permission.profile")}</span>
							</div>
						)}
						<div className="profile_tip">
							<span>
								<img src={SafeIcon} alt="" />
							</span>
							{t("account.profile.tips")}
						</div>
						<Divider />
						<AccountTable actionRef={actionRef} facebookProfiles={facebookProfiles} />
					</div>
				)}
				<ProFilesModal
					open={openProfilesModal}
					data={facebookProfiles}
					onClose={() => setOpenProfilesModal(false)}
					onOkCallBack={() => {
						removeProfileCallBack();
					}}
				/>
			</div>
		</div>
	);
};

export default AdAccount;
